import { useCallback } from 'react';
import { calculateNodePosition } from '../../utils/canvas';
import { getDefaultColor } from '../../utils/colors';
import { saveMap } from '../../utils/storage';

export const useMapOperations = ({
  createNewMap, setCurrentMode, setNodes, setConnections, setMessages, setSuggestions, 
  setExchangesWithoutNodes, setPostIts, setSelectedNode, setSelectedNodes, 
  setSelectedConnection, setModalNode, setInput,
  resetAll, setMapContext
}) => {

  const handleSelectTemplate = useCallback((template) => {
    const newMap = createNewMap();
    setCurrentMode(template.mode || 'brainstormer');
    setMapContext(template.systemPrompt || '');
    const realNodes = [];
    const realConnections = [];
    const tempIdToRealId = {};

    for (const tNode of (template.nodes || [])) {
      const parentNode = tNode.parentTempId ? realNodes.find(n => n.id === tempIdToRealId[tNode.parentTempId]) || null : null;
      const pos = calculateNodePosition(tNode.type, realNodes, realConnections, parentNode);
      const newId = `t${Date.now()}${Math.random().toString(36).substr(2, 4)}`;
      if (tNode.tempId) tempIdToRealId[tNode.tempId] = newId;
      realNodes.push({
        id: newId, type: tNode.type, title: tNode.title, summary: tNode.summary || '',
        description: '', ...pos, banned: false, color: getDefaultColor(tNode.type),
      });
      if (parentNode) realConnections.push({ id: `${parentNode.id}-${newId}`, from: parentNode.id, to: newId });
    }

    setNodes(realNodes);
    setConnections(realConnections);
    setSuggestions([]);
    setExchangesWithoutNodes(0);
    const initMessages = template.initialMessage ? [{ role: 'assistant', content: template.initialMessage }] : [];
    setMessages(initMessages);

    saveMap(newMap.id, {
      nodes: realNodes, connections: realConnections, messages: initMessages,
      postIts: [], reports: [], mode: template.mode || 'brainstormer',
      mapContext: template.systemPrompt || '',
    });
  }, [createNewMap, setCurrentMode, setNodes, setConnections, setMessages, setSuggestions, setExchangesWithoutNodes, setMapContext]);

  const handleReset = useCallback(() => {
    resetAll();
    setMessages([]);
    setInput('');
    setSuggestions([]);
    setSelectedNode(null);
    setSelectedNodes([]);
    setSelectedConnection(null);
    setModalNode(null);
    setExchangesWithoutNodes(0);
    setPostIts([]);
  }, [resetAll, setMessages, setInput, setSuggestions, setSelectedNode, setSelectedNodes, setSelectedConnection, setModalNode, setExchangesWithoutNodes, setPostIts]);

  return {
    handleSelectTemplate,
    handleReset
  };
};
